import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

export const ComponentCard = ({ titulo, valor, porcentagem, cor, descricao }) => {
  return (
    <S.Container borderColor={cor} id="CardStatus">
      <S.Titulo className="tituloCard">{titulo}</S.Titulo>
      {descricao || (
        <p style={{ margin: '0px' }}>
          Existem <b>{valor}</b> Requerimentos, representando <b>{porcentagem}%</b> do total do dia.
        </p>
      )}
    </S.Container>
  );
};

ComponentCard.propTypes = {
  titulo: PropTypes.string,
  valor: PropTypes.number,
  porcentagem: PropTypes.string,
  cor: PropTypes.string,
  descricao: PropTypes.string,
};

ComponentCard.defaultProps = {
  titulo: null,
  valor: null,
  porcentagem: null,
  cor: null,
  descricao: null,
};

export default ComponentCard;
